import React, { useMemo } from "react";
import CreativeMediaPreview from "@/features/campaigns/components/CreativeMediaPreview";

export default function CreativeChannels({ creatives, view }) {
  const getCreativeChannels = useMemo(() => {
    const creative = creatives.find((c) => c.creative_id === view);
    return creative ? creative.package_channels : [];
  }, [creatives, view]);

  return (
    <>
      <div className="creative-channels">
        <div className="card h-100">
          <div className="card-body creative-cerd text-center d-md-flex justify-content-center align-items-center">
            {getCreativeChannels?.map((c) => (
              <div className="mb-1" key={c.id}>
                {/* <Typography color="primary" variant="body2">{c?.creative_name}</Typography> */}
                <CreativeMediaPreview
                  attachment={c?.attachment}
                  channelName={c?.channel_name}
                  creativeName={c?.creative_name}
                  creativeType={c?.creative_type}
                  thumbnail={c?.thumbnail_image || c?.thumbnail || c?.poster}
                  poster={c?.poster}
                  imageClassName="img-fluid rounded"
                  imageStyle={{
                    maxHeight: 300,
                    objectFit: "contain",
                    maxWidth: "90%",
                    display: "inline-block",
                    margin:
                      getCreativeChannels.length === 1 ? "5rem 0" : "auto",
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
